import $ from 'jquery';

export default class {

  static speedFast() {
    return 1;
  }

  static speed() {
    return 2.5;
  }

  static speedSlow() {
    return 3.5;
  }

  // static getKv() {
  //   var tween = new TimelineMax().add([
  //     // TweenMax.set('.mv-op-1', {opacity: 0, y: 100}),
  //     // TweenMax.set('.mv-op-2', {opacity: 0, y: 100}),
  //     // TweenMax.set('.mv-op-3', {opacity: 0, y: 100}),
  //     // TweenMax.set('.mv-op-4', {opacity: 0, y: 100}),
  //     // TweenMax.set('.mv-op-5', {opacity: 0, y: 100}),
  //     // TweenMax.set('.scroll', {opacity: 0, y: 100}),
  //     TweenMax.fromTo('.mv-op-1', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 0,useFrames:true}),
  //     TweenMax.fromTo('.mv-op-2', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 0.3,useFrames:true}),
  //     TweenMax.fromTo('.mv-op-3', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 0.6,useFrames:true}),
  //     TweenMax.fromTo('.mv-op-4', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 0.9,useFrames:true}),
  //     TweenMax.fromTo('.mv-op-5', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 1.1,useFrames:true}),
  //     TweenMax.fromTo('.scroll', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeOut, delay : 1.3,useFrames:true}),
  //   ]);
  //   return tween;
  // }

  static getPcBgLogoKokoro() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.pc-bg-logo-kokoro', 2,{opacity: 0},{opacity: 1, ease: Expo.easeInOut, delay : 0,useFrames:true}),
    ]);
    return tween;
  }

  static getKvFix() {
    var tween = new TimelineMax().add([
      // TweenMax.to('.scroll', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      // TweenMax.to('.mv-op-1', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      // TweenMax.to('.mv-op-2', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      // TweenMax.to('.mv-op-3', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      // TweenMax.to('.mv-op-4', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      // TweenMax.to('.mv-op-5', 0.5,{opacity: 0, ease: Expo.easeInOut,useFrames:true}),
      TweenMax.fromTo('.mv-fix-left', 2,{opacity: 0},{opacity: 1, ease: Expo.easeInOut, delay : 0.3,useFrames:true,onComplete : function(){
        // $('.mv').addClass('mv--fix');
      }}),
      TweenMax.fromTo('.mv-fix-right', 2,{opacity: 0},{opacity: 1, ease: Expo.easeInOut, delay : 0.7,useFrames:true}),
      TweenMax.fromTo('.mv-fix-logo', 2,{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Expo.easeInOut, delay : 1.0,useFrames:true}),
    ]);
    return tween;
  }

  static getBlock1Koma1() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block1-koma1-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma1-txt', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getBlock1Koma2_3() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block1-koma3-img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma2-img', this.speed(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getBlock1Koma4() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block1-koma4-txt', this.speedFast(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma4-img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getBlock1Koma5() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block1-koma5-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma5-img-light', this.speed(),{y: 100},{y: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getBlock1Koma6() {
    var tween = new TimelineMax().add([
      TweenMax.to('.block1-koma5-img-light', this.speedFast(),{opacity: 1, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma6-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma6-txt', this.speed(),{opacity: 0, y: 50},{opacity: 1, y: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getBlock1Koma7() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block1-koma7-img1', this.speedFast(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block1-koma7-img2', this.speedFast(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.2}),
      TweenMax.fromTo('.block1-koma7-txt', this.speedFast(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.4}),
    ]);
    return tween;
  }

  static getBlock2PhotoScale() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block2-photo', this.speedSlow(),{opacity: 0, scale: 0.8, y: 100},{opacity: 1, scale: 1, y: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getBlock2Koma1Scale() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block2-koma1-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block2-koma1-photo', this.speed(),{opacity: 0, scale: 0.8, y: 100},{opacity: 1, scale: 1, y: 0, ease: Power4.easeOut, delay : 0.3}),
    ]);
    return tween;
  }

  static getBlock2Koma2Fuyu() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block2-koma2-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block2-koma2-photo', this.speedSlow(),{opacity: 0},{opacity: 1, ease: Elastic.easeOut, delay : 0.3}),
    ]);
    return tween;
  }

  static getBlock2Koma3Tyaku() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block2-koma3-img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block2-koma3-photo', this.speedSlow(),{opacity: 0, y: -100},{opacity: 1, y: 0, ease: Power4.easeOut, delay : 1}),
    ]);
    return tween;
  }

  static getBlock2Koma4() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block2-koma4-img', this.speed(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block2-koma4-txt', this.speedSlow(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getBlock3Txt() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block3-txt', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getBlock3Koma1() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.block3-koma1-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.block3-koma1-txt', this.speedSlow(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getSekaiYumeKoma1() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.sekai-yume-koma1 img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getSekaiYumeKoma2() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.sekai-yume-koma2 img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
    ]);
    return tween;
  }

  static getSekaiYumeKoma3() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.sekai-yume-koma3 .sekai-yume-img', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.sekai-yume-koma3 .sekai-yume-txt', this.speedSlow(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getSekaiYumeKoma4() {
    // $('.sekai-yume-koma4').css('opacity', 1);
    var tween = new TimelineMax().add([
      TweenMax.set('.sekai-yume-koma4', {opacity: 1}),
      TweenMax.fromTo('.sekai-yume-koma4 .sekai-yume-img', this.speed(),{opacity: 0, y: 100},{opacity: 1, y: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.sekai-yume-koma4 .sekai-yume-txt', this.speedSlow(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

  static getSekaiKokoroTxt() {
    var tween = new TimelineMax().add([
      TweenMax.fromTo('.sekai-kokoro-txt1', this.speed(),{opacity: 0, x: 100},{opacity: 1, x: 0, ease: Power4.easeOut}),
      TweenMax.fromTo('.sekai-kokoro-txt2', this.speedSlow(),{opacity: 0, x: -100},{opacity: 1, x: 0, ease: Power4.easeOut, delay : 0.5}),
    ]);
    return tween;
  }

}
